import React from 'react'
import AppsRoundedIcon from '@mui/icons-material/AppsRounded'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded'
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded'
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded'
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded'
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded'
import SpaRoundedIcon from '@mui/icons-material/SpaRounded'
import { getApplicationImageUrl } from '../../utils/applicationImage'

export const APPLICATION_ICON_OPTIONS = [
  { value: 'apps', label: 'Aplicaciones', Component: AppsRoundedIcon },
  { value: 'local_shipping', label: 'Logistica', Component: LocalShippingRoundedIcon },
  { value: 'receipt_long', label: 'Facturacion', Component: ReceiptLongRoundedIcon },
  { value: 'description', label: 'Documentos', Component: DescriptionRoundedIcon },
  { value: 'fact_check', label: 'Entradas', Component: FactCheckRoundedIcon },
  { value: 'factory', label: 'Produccion', Component: FactoryRoundedIcon },
  { value: 'inventory', label: 'Almacen', Component: Inventory2RoundedIcon },
  { value: 'spa', label: 'Flujos', Component: SpaRoundedIcon },
  { value: 'analytics', label: 'Analisis', Component: AssessmentRoundedIcon },
  { value: 'shield', label: 'Calidad', Component: ShieldRoundedIcon },
]

const iconComponents = Object.fromEntries(APPLICATION_ICON_OPTIONS.map(({ value, Component }) => [value, Component]))

const fallbackIcon = (application) => {
  const key = String(application?.code || application?.title || application?.name || '').toLowerCase()
  if (key.includes('logistic') || key.includes('transport')) return LocalShippingRoundedIcon
  if (key.includes('fact') || key.includes('bill') || key.includes('invoice')) return ReceiptLongRoundedIcon
  if (key.includes('entrada')) return FactCheckRoundedIcon
  if (key.includes('produccion') || key.includes('production')) return FactoryRoundedIcon
  if (key.includes('stock') || key.includes('camara')) return Inventory2RoundedIcon
  if (key.includes('flujo')) return SpaRoundedIcon
  if (key.includes('analisis') || key.includes('analytics')) return AssessmentRoundedIcon
  if (key.includes('campo') || key.includes('quality')) return ShieldRoundedIcon
  return AppsRoundedIcon
}

export const ApplicationIcon = ({ application, size = 24 }) => {
  const imageUrl = getApplicationImageUrl(application?.imageUrl || application?.image_url)
  if (imageUrl) return <img src={imageUrl} alt="" style={{ width: size, height: size, objectFit: 'contain' }} />

  const Icon = iconComponents[application?.icon] || fallbackIcon(application)
  return <Icon sx={{ fontSize: size }} />
}
